import { Popup } from '@progress/kendo-react-popup';
import ClickOutside from 'app/widgets/ClickOutside';
import clsx from 'clsx';
import React, { useEffect, useMemo } from 'react';
import { ActionsListItem } from './types';
import './Menu.less';

interface Props {
  anchorEl?: HTMLElement;
  actions: ActionsListItem[];
  onClose: () => void;
  menuClassName?: string;
}

export default function Menu({
  anchorEl,
  actions,
  onClose,
  menuClassName,
}: Props) {
  const menuOpen = Boolean(anchorEl);

  const activeActions = useMemo(
    () => actions.filter(({ exclude }) => !exclude),
    [actions],
  );

  useEffect(() => {
    const handleScrollClose = () => {
      if (menuOpen) {
        onClose();
      }
    };

    const layoutElement = document.querySelector('.layout');
    const layoutContainerElement = document.querySelector('.layout_container');

    layoutElement?.addEventListener('scroll', handleScrollClose);
    layoutContainerElement?.addEventListener('scroll', handleScrollClose);

    return () => {
      layoutElement?.removeEventListener('scroll', handleScrollClose);
      layoutContainerElement?.removeEventListener('scroll', handleScrollClose);
    };
  }, [menuOpen, onClose]);

  return (
    <Popup
      // Note: React doesn't render this popup correctly when we close it onScroll. The key prop says that it needs to be unmounted.
      key={menuOpen ? 'open' : 'closed'}
      anchor={anchorEl}
      show={menuOpen}
      popupAlign={{ horizontal: 'right', vertical: 'top' }}
    >
      <ClickOutside onClickOutside={onClose}>
        <ul className={clsx('base-menu__list', menuClassName)}>
          {activeActions.map(({ label, action, disabled }, index) => (
            <li
              key={`${label}-${index}`}
              className={clsx('base-menu__item', {
                'base-menu__item_disabled': disabled,
              })}
              onClick={event => {
                event.stopPropagation();

                if (!disabled) {
                  action();
                  onClose();
                }
              }}
            >
              {label}
            </li>
          ))}
        </ul>
      </ClickOutside>
    </Popup>
  );
}
